












import { Vue, Component, Prop } from 'vue-property-decorator';

import PropertyEditor from '@/components/PropertyEditor.vue';
import { BaseDTO } from '@/types';

@Component({
  components: {
    PropertyEditor
  }
})
export default class BooleanInput extends Vue {
  @Prop({ type: Object, required: true }) readonly model!: BaseDTO;
  @Prop({ type: String, required: true }) readonly propertyName!: string;
  @Prop({ type: Array, required: true }) readonly siblings!: string[];

  objectModel: BaseDTO = new BaseDTO();
  editPropertyName = false;

  created () {
    this.objectModel = this.model;
  }

  updateModel () {
    this.$store.dispatch('updateModelProperty', {
      propertyName: this.propertyName,
      oldPropertyName: this.propertyName,
      value: this.objectModel
    });
  };

  editPropName () {
    this.editPropertyName = true;
    this.$nextTick(() => {
      (this.$refs.propertyName as HTMLElement).focus();
    });
  };

  deleteProp () {
    this.$store.dispatch('deleteModelProperty', {
      id: this.model.id
    });
  };
}
